import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Athlete, emptyAthlete } from "../../../../interfaces/athlete";
import { getClubOptions } from "../../../../services/club";
import { getAthleteSingle, updateAthlete } from "../../../../services/athlete";
import { Media } from "../../../../interfaces/media";
import { countriesList } from "../../../../data/countries";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachAthleteEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachAthleteEdit(props: CoachAthleteEditProps) {
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);
    const [media, setMedia] = useState<Media[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            getClubOptions(),
            getAthleteSingle(props.id)
        ]).then((response: any) => {
            setAthlete(response[1].data);
            const newMedia = response[1].data.avatar.map((m: Media) => {
                return m;
            });
            setMedia(newMedia);
            setLoading(false);
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            user_id: event.target.user_id.value,
            first_name: event.target.first_name.value,
            last_name: event.target.last_name.value,
            email: event.target.email.value,
            phone: event.target.phone.value,
            document_id: event.target.document_id.value,
            birthdate: event.target.birthdate.value,
            description: event.target.description.value,
            avatar: media,
            status: event.target.status.checked,
            birth_city: event.target.birth_city.value,
            birth_region: event.target.birth_region.value,
            birth_country: event.target.birth_country.value,
            address: event.target.address.value,
            city: event.target.city.value,
            region: event.target.region.value,
            country: event.target.country.value
        }
        updateAthlete(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="admin-athlete-edit-container" show={ true }
            onHide={ handleClose } size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_athlete") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { loading && 
                    <LoadingSpinner />
                }
                { !loading && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Control type="hidden" name="id" required defaultValue={ athlete.id } />
                            <Form.Control type="hidden" name="user_id" required defaultValue={ athlete.user_id } />
                            <Container>
                                <Row>
                                    <Col xs={12} md={8}>
                                        <Row>
                                            <Col xs={12} md={6}>
                                            <Form.Group className="mb-3" controlId="first_name">
                                                <Form.Label aria-required="true">{ t("first_name") }</Form.Label>
                                                <Form.Control type="text" name="first_name" required defaultValue={ athlete.first_name } disabled={ true } />
                                            </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3" controlId="last_name">
                                                    <Form.Label aria-required="true">{ t("last_name") }</Form.Label>
                                                    <Form.Control type="text" name="last_name" required defaultValue={ athlete.last_name } disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3" controlId="email">
                                                    <Form.Label aria-required="true">{ t("email") }</Form.Label>
                                                    <Form.Control type="email" name="email" defaultValue={ athlete.email } required disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3" controlId="phone">
                                                    <Form.Label>{ t("phone") }</Form.Label>
                                                    <Form.Control type="text" name="phone" defaultValue={ athlete.phone } disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3" controlId="document_id">
                                                    <Form.Label>{ t("document_id") }</Form.Label>
                                                    <Form.Control type="text" name="document_id" defaultValue={ athlete.document_id } disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3" controlId="birthdate">
                                                    <Form.Label>{ t("birthdate") }</Form.Label>
                                                    <Form.Control type="date" name="birthdate" defaultValue={ athlete.birthdate } disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12}>
                                                <Form.Group className="mb-3" controlId="description">
                                                    <Form.Label>{ t("description") }</Form.Label>
                                                    <Form.Control name="description" as="textarea" rows={5} defaultValue={ athlete.description } disabled={ true } />
                                                </Form.Group>
                                            </Col>
                                            { athlete.avatar.length > 0 &&
                                                <Col xs={12}>
                                                    <div className="avatar">
                                                    { athlete.avatar.length > 0 &&
                                                        <img src={ athlete.avatar[0].url } alt={ athlete.name } />
                                                    }
                                                    </div>
                                                </Col>
                                            }
                                            <Col xs={12}>
                                                <Form.Check
                                                    type="switch"
                                                    name="status"
                                                    label={ t("athlete_status_switch_label") }
                                                    defaultChecked={ athlete.status == 1 ? true : false }
                                                    id="status-switch"
                                                    disabled={ true }
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} md={4} style={ { borderLeft: '1px solid #000;'} }>
                                        <div className="left mt-3">
                                            <fieldset className="mb-4" >
                                                <legend>{ t("birth_place") }</legend>
                                                <div>
                                                <Form.Group className="mb-2" controlId="birth_city">
                                                    <Form.Label>{ t("birth_city") }</Form.Label>
                                                    <Form.Control type="text" name="birth_city" defaultValue={ athlete.birth_city } disabled={ true } />
                                                </Form.Group>
                                                <Form.Group className="mb-2" controlId="birth_region">
                                                    <Form.Label>{ t("birth_region") }</Form.Label>
                                                    <Form.Control type="text" name="birth_region" defaultValue={ athlete.birth_region } disabled={ true } />
                                                </Form.Group>
                                                <Form.Group className="mb-2" controlId="team">
                                                    <Form.Label>{ t("birth_country") }</Form.Label>
                                                    <Form.Select aria-label={ t("birth_country") } name="birth_country" defaultValue={ athlete.birth_country } disabled={ true }>
                                                        <option value="">{ t("select_country") }</option>
                                                        { countriesList.map((c: any) => {
                                                            return <option key={ 'birth-country-' + c.code }
                                                                value={ c.code }>{ c.name }</option>
                                                        })}
                                                    </Form.Select>
                                                </Form.Group>
                                                </div>
                                            </fieldset>
                                            <fieldset className="">
                                                <legend>{ t("residence_place") }</legend>
                                                <div>
                                                    <Form.Group className="mb-2" controlId="address">
                                                        <Form.Label>{ t("address") }</Form.Label>
                                                        <Form.Control type="text" name="address" defaultValue={ athlete.address } disabled={ true } />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2" controlId="city">
                                                        <Form.Label>{ t("city") }</Form.Label>
                                                        <Form.Control type="text" name="city" defaultValue={ athlete.city } disabled={ true } />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2" controlId="region">
                                                        <Form.Label>{ t("region") }</Form.Label>
                                                        <Form.Control type="text" name="region" defaultValue={ athlete.region } disabled={ true } />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2" controlId="country">
                                                        <Form.Label>{ t("country") }</Form.Label>
                                                        <Form.Select aria-label={ t("countries") } name="country" defaultValue={ athlete.country } disabled={ true }>
                                                            <option value="">{ t("select_country") }</option>
                                                            { countriesList.map((c: any) => {
                                                                return <option key={ 'country-' + c.code }
                                                                    value={ c.code }>{ c.name }</option>
                                                            })}
                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        <div className="actions">
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
